'use client';

import { c as _c } from "react/compiler-runtime";
import type { SegmentSpendSummary } from '@/domains/pages/ai-spend/utils/map-ai-spend-segments';
import { SegmentPillPicker, SEGMENT_PILL_PICKER_CLASS } from '@/domains/pages/shared/segment-pill-picker';
import { PAGE_DATA_NUMBER_CLASS } from '@/domains/pages/shared/typography';
import { formatSpend } from '@/utils/format.util';
import { cn } from '@/utils/shad';
type SpendSegmentPickerProps = {
  segments: SegmentSpendSummary[];
  selectedName: string;
  onSelect: (name: string) => void;
  className?: string;
};
export function SpendSegmentPicker(t0) {
  const $ = _c(9);
  const {
    segments,
    selectedName,
    onSelect,
    className
  } = t0;
  let t1;
  if ($[0] !== segments) {
    t1 = segments.map(_temp);
    $[0] = segments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn(SEGMENT_PILL_PICKER_CLASS, className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== items || $[5] !== onSelect || $[6] !== selectedName || $[7] !== t2) {
    t3 = <SegmentPillPicker items={items} selectedName={selectedName} onSelect={onSelect} className={t2} />;
    $[4] = items;
    $[5] = onSelect;
    $[6] = selectedName;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(segment) {
  return {
    name: segment.name,
    label: segment.displayName,
    valueLabel: formatSpend(segment.cost),
    valueClassName: PAGE_DATA_NUMBER_CLASS
  };
}